
<template>
  <div class="privacy-wrap">
    <div class="privacy-con">
      <div class="title">《芯医工隐私政策》</div>
      <p>
        芯医工（海南华德科技有限公司，以下简称“我们”）非常尊重用户个人信息的保护，在您使用芯医工提供的服务时，我们将按照本隐私权政策收集、使用及共享您的个人信息。本隐私权政策包含了我们收集、存储、使用、共享和保护您的个人信息的条款，我们希望通过本隐私权政策向您清晰地介绍我们对您个人信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。如您对本隐私权政策有任何疑问，您可以通过芯医工公布的联系方式与我们联系。如果您不同意本隐私权政策任何内容，您应立即停止使用芯医工服务。当您使用芯医工提供的任一服务时，即表示您已同意我们按照本隐私权政策来合法使用和保护您的个人信息。
      </p>
      <h1>一、特别提示</h1>
      <p>
        为用户提供更好、更优的服务是芯医工坚持不懈的追求，也希望通过我们提供的服务可以更方便您的日常运营。本隐私权政策适用于芯医工提供的所有服务，您访问芯医工网站或登陆相关客户端使用芯医工提供的服务，均适用本隐私权政策。
      </p>
      <p>需要特别说明的是，本隐私权政策不适用于其他第三方向您提供的服务。</p>

      <h1>二、我们如何收集信息</h1>
      <p>我们收集信息的方式如下：</p>
      <p>
        1.您向我们提供的信息。
        <span class="bold">
          当您注册芯医工账户以便使用芯医工采购相关产品及/或服务时填写或提交的信息，包括但不限于您的公司名称、公司信息、联系人、公司证照、电话号码、电子邮箱、地址、产品信息及相关附加信息。</span
        >在此过程中，为对您的账号进行验证以实现登录目的，芯医工将按照《芯医工隐私政策》的约定，对您企业进行认证，收集、存储相关信息。
      </p>
      <p>
        2.在您使用服务过程中收集的信息。
        为了提供并优化您需要的服务，我们会收集您使用服务的相关信息，这类信息包括：MAC地址,ANDROID
        ID
      </p>
      <p class="bold">
        在您使用芯医工服务，或访问芯医工网页时，芯医工自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、
        访问日期和时间、软硬件特征信息及您需求的网页记录等数据；如您下载或使用芯医工或其关联公司客户端软件，或访问移动网页使用芯医工服务时，芯医工可能会读取与您位置和移动设备相关的信息，包括但不限于设备型号、设备识别码、操作系统、分辨率、电信运营商等。
      </p>
      <p>
        如您需修改向您展示的商品或服务排序或者商业性广告及其他内容，可通过以下方式实现：
      </p>
      <p>
        1）
        如您不想接收搜索页为您综合的商品或服务，可以选择按销量、价格或者其他页面可选的维度接收相应的搜索结果展示；
      </p>
      <p>
        2）
        如您不想接收商业性短信，可以根据短信内容提示，来取消我们给您发送的手机促销短信；
      </p>
      <p>
        3）
        如您不想接收APP发送的消息通知，可以通过“设置-消息通知”关闭芯医工APP通知；
      </p>
      <p>
        除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，<span
          class="bold"
        >
          包括您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与芯医工的关联方、芯医工合作伙伴之间互动时我们收集的相关信息。</span
        >与此同时，为提高您使用芯医工提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，<span
          class="bold"
        >
          我们可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。</span
        >
      </p>
      <p>3.来自第三方的信息</p>
      <p>
        为了给您提供更好、更优的服务，或共同为您提供服务，或为了预防互联网欺诈的目的，芯医工的关联方、合作伙伴会依据法律的规定或与您的约定或征得您同意的前提下，向芯医工分享您的个人信息。您了解并同意，以下信息不适用本隐私权政策：
      </p>
      <p class="bold">
        a）您在使用芯医工提供的搜索服务时输入的关键字信息；
      </p>
      <p class="bold">
        b）信用评价、违反法律规定或违反芯医工规则行为及芯医工已对您采取的措施；
      </p>
      <p class="bold">
        c）应法律法规要求需公示的企业名称等相关工商注册信息以及自然人经营者的信息。
      </p>
      <p>
        4.芯医工APP涉及嵌入第三方代码、插件传输个人信息的情形，我们会对第三方SDK进行严格的安全检测，并要求合作伙伴采取严格的措施来保护您的个人数据。在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK，并及时在本说明中向您公开说明接入第三方SDK的最新情况。逐项列举:
      </p>
      <p>
        a）极光推送SDK:用于项目消息推送，主要推送项目的订单进度或未支付的提醒;我们的产品商城服务，需要获取修改/删除SD卡的权限。
      </p>
      <p class="bold">收集个人信息字段︰网络身份标识信息</p>
      <p class="bold">自启动和关联启动说明</p>
      <p class="bold">
        ①为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用（自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为是因实现功能及服务所必要的。
      </p>
      <p class="bold">
        ②当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在末征得您同意的情况下，则不会有自启动或关联启动。
      </p>
      <p>所属机构︰深圳市和讯华谷信息技术有限公司</p>
      <p>
        b）小米推送SDK:用于项目消息推送，主要推送项目的订单进度或未支付的提醒;我们的产品商城服务，需要获取修改/删除SD卡的权限。
      </p>
      <p class="bold">收集个人信息字段︰网络身份标识信息、软件安装列表</p>
      <p class="bold">自启动和关联启动说明</p>
      <p class="bold">
        ①为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用（自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为是因实现功能及服务所必要的。
      </p>
      <p class="bold">
        ②当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在末征得您同意的情况下，则不会有自启动或关联启动。
      </p>
      <p>所属机构：小米科技有限责任公司</p>
      <p>
        c）华为推送SDK:用于项目消息推送，主要推送项目的订单进度或未支付的提醒;我们的产品商城服务，需要获取修改/删除SD卡的权限。
      </p>
      <p class="bold">收集个人信息字段︰网络身份标识信息、软件安装列表</p>
      <p class="bold">自启动和关联启动说明</p>
      <p class="bold">
        ①为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用（自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为是因实现功能及服务所必要的。
      </p>
      <p class="bold">
        ②当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在末征得您同意的情况下，则不会有自启动或关联启动。
      </p>
      <p>所属机构：华为技术有限公司</p>
      <p>d）腾讯bugly SDK:用于云平台、企业协作、辅助运营</p>
      <p class="bold">
        收集个人信息字段︰ANDROID ID、Wifi信息、MAC地址、IMSI、bssid、IMEI
      </p>
      <p>所属机构：深圳市腾讯计算机系统有限公司</p>
      <p>
        e）友盟
        SDK:用于提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力
      </p>
      <p class="bold">收集个人信息字段︰个人常用设备信息</p>
      <p>所属机构：北京锐讯灵通科技有限公司</p>
      <p>
        f）腾讯浏览服务
        SDK:用于提供浏览增强，内容框架，广告体系，H5游戏分发，大数据等服务，提升应用体验
      </p>
      <p class="bold">收集个人信息字段︰个人常用设备信息</p>
      <p>所属机构：深圳市腾讯计算机系统有限公司</p>
      <p>g）微信 SDK:用于将商品、活动分享到朋友圈和微信好友</p>
      <p class="bold">收集个人信息字段︰网络身份标识信息、个人常用设备信息</p>
      <p>所属机构：深圳市腾讯计算机系统有限公司</p>
      <p>
        h）腾讯云 SDK:用于同用户开展线上沟通交流（包括语音或手机内的录音信息）
      </p>
      <p class="bold">
        收集个人信息字段︰网络身份标识信息、个人基本信息、个人常用设备信息
      </p>
      <p class="bold">
        当您需要发送语音信息时，我们会收集您的语音或手机内的录音内容，因为收集是实现该功能所必须的；同时，若您需要发送图片信息时，我们将申请您手机的相册访问权限，只有在获得您的授权后才可正常使用，若您需要拍照发送时，我们将申请您的相机权限，只有在获得您的授权后才可正常使用。
      </p>
      <p>所属机构：深圳市腾讯计算机系统有限公司</p>
      <p>
        i）百度统计SDK：为帮助我们使用统计、分析服务，以便了解用户如何使用移动应用程序；
      </p>
      <p class="bold">
        收集个人信息字段︰MAC地址、IMSI、bssid、IMEI、日志信息、应用程序列表信息、剪切板中的口令、链接等内容；
      </p>
      <p>所属机构：北京百度网讯科技有限公司。</p>
      <p>
        j）ColorOS SDK：用于消息推送，用户账号相关促销活动、消息提醒更新时；
      </p>
      <p class="bold">
        收集个人信息字段︰匿名用户ID。SDK本机采集，不涉及数据共享；
      </p>
      <p class="bold">自启动和关联启动说明</p>
      <p class="bold">
        ①为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用（自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为是因实现功能及服务所必要的。
      </p>
      <p class="bold">
        ②当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在末征得您同意的情况下，则不会有自启动或关联启动。
      </p>
      <p>所属机构：OPPO广东移动通信有限公司。</p>
      <p>
        k）腾讯开放平台SDK：用于快速登录、支付、互动等功能，支持将页面分享出去；
      </p>
      <p class="bold">
        收集个人信息字段︰个人常用设备信息、设备识别信息。SDK本机采集，不涉及数据共享；
      </p>
      <p>所属机构：深圳市腾讯计算机系统有限公司。</p>
      <p>
        l）阿里一键登录SDK：在您注册/登录账户时，您需要提供手机号码及验证码，使用App服务时，您也可使用手机号码一键登录功能；
      </p>
      <p class="bold">
        收集个人信息字段︰可能收集您的网络类型、设备信息（IP地址、设备制造商、设备型号、手机操作系统、应用程序供应商标志符（IDFV）、SIM卡或国际移动用户识别码（IMSI）信息等）
      </p>
      <p>所属机构：阿里云计算有限公司。</p>
      <p class="bold">
        获取陀螺仪传感器、加速度传感器的说明：当您使用创新广告交互功能（如摇动、扭动、扭转设备）时，我们会调用设备的陀螺仪、加速度、重力传感器以识别判断您的设备状态。请您理解，单独的设备传感器数据不涉及任何个人位置信息且无法与其他信息结合用于识别特定自然人的身份。
      </p>
      <p class="bold">
        个人基本信息包含：个人姓名、生日、性别、民族、国籍、家庭关系、联系地址、个人电话号码、电子邮箱
      </p>
      <p class="bold">
        网络身份标识信息：包含系统账号、IP地址、邮箱地址及与前述有关的密码、口令、口令保护答案、用户个人数字证书
      </p>
      <p class="bold">
        个人常用设备信息：包含硬件序列号、设备MAC地址、软件列表、唯一设备识别码（如IMEI/android
        ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息)在内的描述个人常用设备基本情况的信息
      </p>
      <p class="bold">
        （1）个推·消息推送，包名信息为com.igexin.push，涉及个人信息：存储的个人文件、设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI）、应用已安装列表、网络信息；
      </p>
      <p class="bold">
        （2）华为 HMS
        push，包名信息为com.huawei.hms，涉及个人信息：设备信息（IMEI、ANDROID_ID、DEVICE_ID、IMSI）、应用已安装列表、网络信息；
      </p>
      <p class="bold">
        （3）OPPO push，包名信息为com.heytap.msp，涉及个人信息：网络信息；
      </p>
      <p class="bold">
        （4）小米推送，包名信息为com.xiaomi.push涉及个人信息：网络信息；
      </p>
      <p class="bold">
        （5）支付宝开放平台，包名信息为com.alipay，涉及个人信息：网络信息 设备id
        IP地址 OAID IMSI；
      </p>
      <p class="bold">我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《DCloud用户服务条款》。（DCloud用户服务条款超链至：https://ask.dcloud.net.cn/protocol.html）</p>
      <h1>三、我们如何使用信息</h1>
      <p>
        因收集您的信息是为了向您提供服务及提升服务质量的目的，为了实现这一目的，我们会把您的信息用于下列用途：
      </p>
      <p>1.向您提供您使用的各项服务，并维护、改进这些服务。</p>
      <p>
        2.我们可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、其他我们用户，或我们或其关联方的合法权益。
      </p>
      <p>
        3.我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于为了给您提供服务使用，例如让您拥有更广泛的社交圈的需要而使用、共享或披露。
      </p>
      <p>4.经您许可的其他用途。</p>
      <h1>四、我们如何共享信息</h1>
      <p>
        我们对您的信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租您的任何信息，我们会在下列情况下才将您的信息与第三方共享：
      </p>
      <p>1.事先获得您的同意或授权。</p>
      <p>2.根据法律法规的规定或行政或司法机构的要求。</p>
      <p>3.向芯医工的关联方分享您的个人信息。</p>
      <p>
        4.向可信赖的合作伙伴提供您的个人信息，让他们根据我们的指示并遵循我们的隐私权政策以及其他任何相应的保密和安全措施来为我们处理这些信息。
      </p>
      <p>
        5.如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。
      </p>
      <p>
        6.只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。例如您在芯医工上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，芯医工会视情况<span
          class="bold"
        >
          向该用户提供其交易对方的联络方式等必要信息</span
        >，以促成交易的完成或纠纷的解决。
      </p>
      <p>
        7.如您出现违反中国有关法律、法规或者芯医工相关协议或相关规则的情况，需要向第三方披露。
      </p>
      <p>8.为维护芯医工及其关联方或用户的合法权益。</p>
      <h1>五、Cookie 和网络 Beacon 的使用</h1>
      <p>
        为使您获得更轻松的访问体验，您访问芯医工相关网站或使用芯医工提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。<span
          class="bold"
        >
          这些数据文件可能是Cookie，Flash
          Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。</span
        >
      </p>
      <p>
        请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝芯医工的Cookie，但这一举动在某些情况下可能会影响您安全访问芯医工相关网站和使用芯医工提供的服务。
      </p>
      <p>
        网页上常会包含一些电子图象（称为"单像素" GIF 文件或 "网络
        beacon"），使用网络beacon可以帮助网站计算浏览网页的用户或访问某些cookie，<span
          class="bold"
          >我们会通过网络beacon收集您浏览网页活动的信息，
          例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</span
        >
      </p>
      <h1>六、信息存储</h1>
      <p>
        芯医工收集的有关您的信息和资料将保存在芯医工及其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或芯医工收集信息和资料所在地并在该地被访问、存储和展示。
      </p>
      <h1>七、您的个人信息保护</h1>
      <p>
        为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们
        签署保密协议，监控他们的操作情况等措施。芯医工会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，芯医工将尽力做到使您的信息不被泄漏、
        毁损或丢失。
        您的账户均有安全保护功能，请妥善保管您的账户及密码信息。芯医工将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。
        在使用芯医工服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络芯医工客服，以便芯医工采取相应措施。
      </p>
      <h1>八、注销账户</h1>
      <p class="bold">
        您可以在我们的产品中直接申请注销账户。您可以通过移动端APP访问我的-账户信息-注销账号来完成账号注销。您注销账户后，我们将停止为您提供产品以及关联服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息，其中包括：您的所有交易记录将被清空，请确保所有交易已完结且无纠纷，账号注销后因历史交易可能产生的退换货、维权相关的资金退回等权益将视作自动放弃；您未使用的优惠券、积分等会员权益将被清空；支持芯医工账号登录的多项产品/服务将无法使用此账号（如医械购、科研购、集采平台等）。
      </p>
      <p class="bold">账号注销流程：发送邮箱至public@hiwald.com，将于3工作日内注销账号。</p>
      <p>
        本协议适用海南华德科技有限公司名下的芯医工APP、m.vedeng.com以及vedeng.com
      </p>
      <p>版本更新日期：2023年5月24日（增加第三方SDK收集语音等权限说明）</p>
      <p>版本生效日期：2023年5月24日</p>
      <p>开发者：海南华德科技有限公司</p>
      <p>如对本隐私协议或相关事宜有任何问题，您可随时通过以下方式联系我们：</p>
      <p class="bold">联系电话：0898-65305790。</p>
      <p class="bold">地址：海南省海口市龙华区国贸路6号瑞特广场2303</p>
    </div>
  </div>
</template>
  <script>
export default {
  name: "privacyAct",

  data() {
    return {};
  },

  mounted() {},
  methods: {},
};
</script>
  
  <style scoped>
.bold {
  font-weight: bold;
  color: #333;
}
.privacy-con {
  box-sizing: border-box;
}
.privacy-wrap {
  padding: 10px 20%;
  background-color: #eaeaea;
}
.title {
  font-size: 28px;
  color: #333;
  text-align: center;
}
h1 {
  font-size: 22px;
  color: #333;
}
p {
  color: #333;
  font-weight: 400;
  text-indent: 36px;
  font-size: 18px;
}
</style>
  


// WEBPACK FOOTER //
// src/view/PrivacyPolicy.vue